import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class DomainGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(): boolean {
    const currentDomain = window.location.hostname;
    
    if (!currentDomain.endsWith('localhost') && !currentDomain.endsWith('new.traveler-assistance.com') && !currentDomain.endsWith('staging.traveler-assistance.com') && !currentDomain.endsWith('ec.traveler-assistance.com')  ) {
      this.router.navigate(['/cotizador-de-proveedores']);
      return false;
    }
    
    return true;
  }
}